/**
 * Created by zhangrp on 2019/8/2.
 */

export const groups_retail = [
    {
        name: '资产',
        checked: false,
        indeterminate: false,
        sysRescs: [],
        scope: [
            'shopDeviceList',
            'shopDeviceSuit',
            'assetCheck',
            'deviceTransVoucher',
            'fixedAssetsInStorage',
            'shopDeviceImp',
            'fixedAssetsApply',
            'fixedAssetsReturn',
            'fixedAssetsClear',
            'shopDeviceScrap',
            'requireApply',
            'requireVoucher',
            'assetIoIn',
            'asserIoOut',
            'comLocation',
            'assetCheckHandle',
        ]
    },
    {
        name: '维保',
        checked: false,
        indeterminate: false,
        sysRescs: [],
        scope: [
            'sweepReq',
            'faultReq',
            'reqVoucher',
            'reqComnRepair',
            'outerRepairRec',
            'accStockList',
            'accUseturnList',
            'devcMaintRec',
            'createServcWorkVoucher',
            'shopDeviceMaintainList',
        ]
    },
    {
        name: '数据',
        checked: false,
        indeterminate: false,
        sysRescs: [],
        scope: [
            'shopDeviceFiscalList',
            'shopDeviceRecList',
            'assetStorage',
            'fixedAssetsIoRecord',
            'deviceMaintPlan',
            'patrolRec',
            'fellBillCollect',
            'fellBillList',
            'devcMaintVoucherList',
        ]
    },
    {
        name: '监控',
        checked: false,
        indeterminate: false,
        sysRescs: [],
        scope: [
            'doorCtrlScanCode',
            'shopDevcDoor',
        ]
    },
    {
        name: '人事',
        checked: false,
        indeterminate: false,
        sysRescs: [],
        scope: [
            'roleList',
            'handoveManf',
            'staffManage',
            'comStaffManage',
        ]
    },
    {
        name: '供应协同',
        checked: false,
        indeterminate: false,
        sysRescs: [],
        scope: [
            'awaitRecvList',
            'recvVoucher',
            'address',
        ]
    }
];



//////////////////
// WEBPACK FOOTER
// ./src/compo/authx/authxGroups.js
// module id = 379
// module chunks = 0